/**
 * Vue下拉框数据查询与存储工具
 */

// 导入模块
import { fetchSelect as fetchChannel } from '@/view/channel/channel'; //资源名称
import { fetchSelect as fetchMember } from '@/api/member'; //渠道名称
import { fetchSelect as fetchUser } from '@/view/user/comUser'; //员工信息
import { fetchSelect as fetchErsAccount } from '@/api/ersAccount';  //渠道名称
import {fetchSelect2 as fetchGoods2} from '@/api/comGoods';  //产品
import { getTableMap } from '@/api/common/table';  //产品

class SelectManager {
    configs = {
        channelOption:fetchChannel,
        memberOption:fetchMember,
        userOption:fetchUser,
        ersAccountOption:fetchErsAccount,
        goodsOption2:fetchGoods2,
        tableMap:getTableMap,
    }
    constructor() {
    }

    initialize(vueInstance,selectData,selectMap={}) {
        this.vueInstance = vueInstance;
        this.selectData = selectData;
        this.selectMap = selectMap;
    }

    /**
     * 根据key加载数据
     * @param {string} key - 注册的key
     * @param param 查询参数
     * @param dataName
     * @returns {Promise<Array>} - 转换后的选项列表
     */
    async getOption(key,param= {},dataName=key) {
        const config = this.configs[key];
        if (!config) {
            throw new Error(`未找到key为"${key}"的配置`);
        }

        try {
            const response = await config(param);
            if (response.code !== '200') {
                throw new Error(`请求失败 [code: ${response.code}, msg: ${response.message || '未知错误'}]`)
            }
            // 提取数据字段
            const data = response.data || []

            // 使用$set设置到Vue实例对应属性中
            this.vueInstance.$set(this.selectData, dataName, data)
        } catch (error) {
            console.error(`获取下拉数据失败 [key: ${dataName}]`, error)
            this.vueInstance.$set(this.selectData, dataName, [])
        }
    }
    async getOptionAndMap(key,param= {}) {
        const config = this.configs[key];
        if (!config) {
            throw new Error(`未找到key为"${key}"的配置`);
        }

        try {
            const response = await config(param);
            if (response.code !== '200') {
                throw new Error(`请求失败 [code: ${response.code}, msg: ${response.message || '未知错误'}]`)
            }
            // 提取数据字段
            const data = response.data || []

            // 使用$set设置到Vue实例对应属性中
            this.vueInstance.$set(this.selectData, key, data)

            const dataMap = {};
            data.forEach(d=>{
                let optKey = d.optKey;
                dataMap[optKey] = d;
            })
            this.vueInstance.$set(this.selectMap,key, dataMap)
        } catch (error) {
            console.error(`获取下拉数据失败 [key: ${key}]`, error)
            this.vueInstance.$set(this.selectData, key, [])
        }
    }

    formatSelect(selectKey,code,defValue={},key={}){
        const {def='***',defKeyValue = '无',defValueValue = "未知",prefix = "",suffix=""} = defValue;
        const {optKey='optKey',optVal="optVal"} = key;
        let result;

        if (!code){
            return defKeyValue;
        }

        if (this.selectMap[selectKey]){
            result = this.selectMap[selectKey][code];
        }else if (this.selectData[selectKey]){
            result = this.selectData[selectKey].find(item => item[optKey] === code);
        }else {
            return def;
        }

        return result ? prefix + result[optVal] + suffix : defValueValue;
    }

    formatSelect2(code,data,defValue={},key={}){
        console.log(code,data);
        const {def='***',defKeyValue = '无',defValueValue = "未知",prefix = "",suffix=""} = defValue;
        const {optKey='optKey',optVal="optVal"} = key;
        let result;

        if (!code){
            return defKeyValue;
        }

        if (Array.isArray(data)){
            result = data.find(item => item[optKey] === code);
        }else if (data instanceof Object){
            result = data[code];
        }else {
            return def;
        }

        return result ? prefix + result[optVal] + suffix : defValueValue;
    }
}

// 创建并导出单例实例
export default new SelectManager()
